<template>
    <div>
        <keen-message-address-input
            v-model="message.to"
            :disabled="isSending||disabled"
            v-if="!replyMode && !hideToField"
        />

        <ui-textbox
          label="Subject"
          v-model="message.subject"
          :disabled="isSending||disabled"
          v-if="!replyMode"
        />

        <tiptap-message-field
            ref="editor"
            @ready="editorReady($event)"
            v-model="message.content"
            :disabled="isSending||disabled"
        />

        <div style="margin: 1rem 0; display: flex; gap: 0.5rem; align-items: center;">
            <insert-template-button
                :disabled="isSending||disabled||!contactId"
                :format="'html'"
                :contact-id="contactId"
                @template-selected="handleTemplateSelected"
            />
            <composer-attachment-pane
                v-model="message.attachments"
                style="flex: 1;"
            ></composer-attachment-pane>
        </div>

        <div class="row" style="margin-top: 1rem;">
            <div class="col">
                <message-box-dropdown-selector
                    v-model="message.message_box"
                    :disabled="isSending||disabled"
                    v-if="!replyMode"
                />
                <ui-icon-button
                    v-if="replyMode"
                    type="secondary"
                    icon="delete"
                    :disabled="isSending||disabled"
                    @click="$emit('reset')"
                />
            </div>
            <div class="col-8 text-right">
                <div class="ui-select-horizontal">
                    <ui-select
                        label="Status:"
                        v-model="assignStatus"
                        :options="statusList"
                        style="margin-bottom: 0;"
                    ></ui-select>
                </div>
                <ui-button
                    icon="send"
                    color="primary"
                    :disabled="disabled"
                    :loading="isSending"
                    @click="send"
                >Send</ui-button>
            </div>
        </div>
    </div>
</template>

<script>
    import MessageBoxDropdownSelector from "./MessageBoxDropdownSelector";
    import KeenMessageAddressInput from "./KeenMessageAddressInput";
    import { MessageTypes} from "../../classes/Api/Inbox";
    import TiptapMessageField from "./TiptapMessageField";
    import ComposePaneBase from "./ComposePaneBase";
    import DocumentPickerModal from "../elements/DocumentPickerModal";
    import ComposerAttachmentPane from "./ComposerAttachmentPane";
    import InsertTemplateButton from "./InsertTemplateButton.vue";
    import {nextTick} from "vue";

    export default {
        extends: ComposePaneBase,
        components: {
            InsertTemplateButton,
            ComposerAttachmentPane,
            DocumentPickerModal,
            TiptapMessageField,
            KeenMessageAddressInput,
            MessageBoxDropdownSelector
        },
        data() {
            return {
                editor: null,
                selectedTemplate: null,
                templateContent: null
            }
        },
        methods: {
            beforeSend() {
                if (!this.message.content.startsWith(this.baseContentStyles)) {
                    this.message.content = this.baseContentStyles + this.message.content
                }
            },
            setContent(content) {
                this.message.content = content
            },
            handleTemplateSelected(data) {
                this.selectedTemplate = data.template
                this.templateContent = data.content + this.defaultContent
                this.message.content = data.content + this.defaultContent

                nextTick(() => {
                    this.addSignature()
                })
            },
            clearTemplate() {
                this.selectedTemplate = null
                this.templateContent = null
                this.message.content = this.defaultContent + this.defaultSignature
            },
            onReset() {
                this.clearTemplate()
            },
            editorReady(editorInstance) {
                this.editor = editorInstance

                this.editor.chain().focus('start').run()
            },
            addSignature() {
                if (this.defaultSignature && this.editor) {
                    this.editor.chain().focus('end').insertContent(this.defaultSignature).run()
                    this.editor.chain().focus('start').run()
                }
            }
        },
        computed: {
            defaultContent() {
                return ''
            },
            defaultSignature() {
                return window.marque.ui.signatures.email
            },
            baseContentStyles() {
                return '<style>ol > li > p, ul > li > p { margin: 0; } * { font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji }</style>'
            },
            conversation() {
                return this.$store.getters['inbox/conversations/conversation']
            },
            messageMedium() {
                return MessageTypes.TYPE_EMAIL
            },
            messageRecipients() {
                return this.message.to.email ?
                    this.message.to.email : this.message.to.primary_display_as
            },
            contactId() {
                if (this.replyMode && this.conversation && this.conversation.contact) {
                    return this.conversation.contact.id
                }

                if (this.message && this.message.to) {
                    return this.message.to.id
                }

                return null
            }
        }
    }
</script>

<style scoped>
    .template-iframe-container {
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        margin-bottom: 1rem;
    }

    .template-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem;
        background-color: #f5f5f5;
        border-bottom: 1px solid #e0e0e0;
    }

    .template-iframe {
        width: 100%;
        min-height: 300px;
        border: none;
        display: block;
    }
</style>